module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_9005.91d34621.png";